import axios from 'axios';
import { API_BASE } from '../config/api';

const API = `${API_BASE}/api`;

export const periodLabel = (unit, position, title) =>
  title && title.toLowerCase().includes(`${unit} ${position}`.toLowerCase()) ? title : `${unit} ${position}${title ? `: ${title}` : ''}`;

async function downloadDocx(url, token, fallbackName) {
  let res;
  try {
    res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' });
  } catch (e) {
    const text = e.response?.data instanceof Blob ? await e.response.data.text() : '';
    let detail = '';
    try { detail = JSON.parse(text).detail; } catch (_) { /* not JSON */ }
    throw new Error(detail || 'Download failed');
  }
  const disposition = res.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^"]+)"?/);
  const href = window.URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = href;
  a.download = match ? match[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(href);
}

// Downloads a weekly study guide .docx with the auth header (no token in URL).
export const downloadStudyGuide = (programmeId, periodId, token, fallbackName = 'Study_Guide.docx') =>
  downloadDocx(`${API}/programmes/${programmeId}/periods/${periodId}/study-guide/download`, token, fallbackName);

// Downloads the combined module study guide (all approved weekly guides in the module).
export const downloadModuleGuide = (programmeId, moduleId, token, fallbackName = 'Module_Study_Guide.docx') =>
  downloadDocx(`${API}/programmes/${programmeId}/modules/${moduleId}/study-guide/download`, token, fallbackName);

// Downloads a module's Study Notes (AI .docx or the admin-uploaded file).
export const downloadModuleNotes = (programmeId, moduleId, token, fallbackName = 'Study_Notes') =>
  downloadDocx(`${API}/programmes/${programmeId}/modules/${moduleId}/study-notes/download`, token, fallbackName);
